import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_message_wrap, {
      isShowMessageTail: _ctx.isShowMessageTail,
      message: _ctx.message,
      avatar: _ctx.avatar,
      onInit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('init')))
    }, null, 8, ["isShowMessageTail", "message", "avatar"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttonsAsCheckbox, (button, index) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          key: index,
          label: button.text,
          ripple: false,
          color: _ctx.isSelected(button.params.order) ? 'white' : 'primary',
          "text-color": _ctx.isSelected(button.params.order) ? 'primary' : 'white',
          class: "button button-checkbox",
          onClick: ($event: any) => (_ctx.toggleButton(button.params.order))
        }, null, 8, ["label", "color", "text-color", "onClick"]))
      }), 128)),
      _createVNode(_component_q_btn, {
        label: _ctx.$t(_ctx.continueButton.text),
        color: "primary",
        "text-color": "white",
        class: "button button-continue",
        onClick: _ctx.send
      }, null, 8, ["label", "onClick"])
    ], 512), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
}